// extracted by mini-css-extract-plugin
export default {"fieldList":"Metrics_tsx_fieldList__NLBsV"};